import script from "./JournalCover.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalCover.vue?vue&type=script&setup=true&lang=js"

import "./JournalCover.vue?vue&type=style&index=0&id=3cb960e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb960e7"]])

export default __exports__